import React from 'react';
import { CheckCircle, Clock, Circle, Download, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import SubTask from '@/components/SubTask';
import DownloadReportField from '@/components/DownloadReportField';

interface Step7CompletionProps {
  vendor: string;
  onPublishToShopifyAndFC: () => void;
  stepSevenTasks?: any;
}

const Step7Completion: React.FC<Step7CompletionProps> = ({
  vendor,
  onPublishToShopifyAndFC,
  stepSevenTasks
}) => {

  const subTasks = stepSevenTasks?.subTasks || [];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Sub Tasks Section */}
      <SubTask subTasks={subTasks} />

      {/* Status Section */}
      <Card className="bg-white border border-gray-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Status</CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Publish to Stage */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-medium">Publish to Stage</h3>
            </div>

            {/* Download Report Button */}
            <DownloadReportField status='pending' rawProductFeedValidationReportLocation='' />

            {/* Publish To Shopify & FC Button */}
            <Button
              onClick={onPublishToShopifyAndFC}
              className="w-full bg-teal-600 hover:bg-teal-700 text-white flex items-center justify-center gap-2"
            >
              Publish To Prod
              <ArrowRight className="h-4 w-4" />
            </Button>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-sm text-gray-600">Status:</span>
                <Badge className="bg-blue-100 text-blue-700">{stepSevenTasks?.status || 'Pending'}</Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Step7Completion; 